import { PrimeVueConfiguration } from 'primevue/config'
import Aura from '@primeuix/themes/aura'
import { definePreset } from '@primeuix/themes'
import { ComponentsDesignTokens } from '@primeuix/themes/types'
import SwipeVuePassThroughOptions from '@/core/configs/SwipeVuePassThroughOptions'
import DutchLocaleOptions from 'primelocale/nl.json'

const primitive = {
  indigo: {
    50: '#f2f2ff',
    100: '#e6e6ff',
    200: '#bfbfff',
    300: '#9999ff',
    400: '#4d4dff',
    500: '#151558',
    600: '#12124c',
    700: '#0e0e40',
    800: '#0b0b33',
    900: '#080827',
    950: '#070722',
  },
  orange: {
    50: ' #fffdf5',
    100: ' #fff9e6',
    200: ' #fff2bf',
    300: ' #ffe999',
    400: ' #ffd94d',
    500: ' #f7b500',
    600: ' #d99d00',
    700: ' #b98a00',
    800: ' #997600',
    900: '#806300',
  },
}

/**
 * Semantic Tokens:
 * These are context-driven tokens with names that indicate their purpose (e.g., primary.color) and map to primitive
 * or other semantic tokens, often adapting to themes like dark mode.
 */
const semantic = {
  primary: {
    50: '{indigo.50}',
    100: '{indigo.100}',
    200: '{indigo.200}',
    300: '{indigo.300}',
    400: '{indigo.400}',
    500: '{indigo.500}',
    600: '{indigo.600}',
    700: '{indigo.700}',
    800: '{indigo.800}',
    900: '{indigo.900}',
    950: '{indigo.950}',
  },

  focusRing: {
    width: '0px',
    style: 'solid',
    color: '{primary.color}',
    offset: '1px',
  },
}

/**
 * Component Tokens:
 * These are tokens specific to components (e.g., button.background) that map to semantic tokens,
 * which in turn map to primitive tokens.
 *
 * The tokens for each component are defined on the
 */
const components: ComponentsDesignTokens = {
  paginator: {
    navButton: {
      height: '1.75rem',
      width: '1.75rem',
      selectedBackground: '{gray.100}',
    },
  },
}

/**
 * The core of the styled mode architecture is based on a concept named design token, a preset defines the
 * token configuration in 3 tiers; primitive, semantic and component.
 */
export default {
  locale: DutchLocaleOptions.nl,
  theme: {
    preset: definePreset(Aura, {
      primitive,
      semantic,
      components ,
    }),
    options: {
      darkModeSelector: '.none',
      cssLayer: false,
    },
  },
  ptOptions: {
    mergeProps: true,
  },
  pt: SwipeVuePassThroughOptions,
} as PrimeVueConfiguration
